import config from "../../config/config.json";
import { getHeaders } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse
} from "../../APIHelpers/Responses";

export const superAdminMetaServices = {
  getMetadataList,
  getFormList,
  getCategoryMetaList,
  getSingleMetadata,
  getSingleCategoryMeta,
};

// Get Form List
async function getFormList(auth, categoryId) {
  try {
    const signal = cancelPreviousRequest(`getFormList/${categoryId}`);
    let apiURL = `${config.API_URL_USER_ONBOARDING}getFormList/${categoryId}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", getHeaders(auth)),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if(data?.statusCode === 401 || data?.statusCode === 423){
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get All Metadata
async function getMetadataList(auth, categoryId) {
  try {
    const signal = cancelPreviousRequest(`getMetadataList/${categoryId}`);
    let apiURL = `${config.API_URL_USER_ONBOARDING}getMetadataList/${categoryId}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", getHeaders(auth)),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if(data?.statusCode === 401 || data?.statusCode === 423){
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get All Category Meta
async function getCategoryMetaList(auth, type) {
  try {
    const signal = cancelPreviousRequest(`getCategoryMetaList/${type}`)
    let apiURL = `${config.API_URL_USER_ONBOARDING}getCategoryMetaList/${type}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", getHeaders(auth)),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if(data?.statusCode === 401 || data?.statusCode === 423){
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Single Metadata
async function getSingleMetadata(auth, categoryId, key) {
  try {
    const signal = cancelPreviousRequest(`getSingleMetadata/${categoryId}/${key}`)
    let apiURL = `${config.API_URL_USER_ONBOARDING}getSingleMetadata/${categoryId}/${key}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", getHeaders(auth)),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if(data?.statusCode === 401 || data?.statusCode === 423){
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Single Category Meta
async function getSingleCategoryMeta(auth, key) {
  try {
    const signal = cancelPreviousRequest(`getSingleCategoryMeta/${key}`)
    let apiURL = `${config.API_URL_USER_ONBOARDING}getSingleCategoryMeta/${key}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", getHeaders(auth)),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if(data?.statusCode === 401 || data?.statusCode === 423){
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}